import { Loader2, CheckCircle2, ArrowRight } from "lucide-react";

// Email-verification panel for anonymous (non-logged-in) case submitters.
// The parent owns all state — this is purely a presentation + a thin set of
// callbacks back into the orchestrator.
export function WorkflowVerifyPanel({
    emailVerify,
    verifyCode,
    setVerifyCode,
    verifyError,
    setVerifyError,
    resendCooldown,
    submitting,
    onSubmit,
    onBack,
    onResend,
}) {
    return (
        <div data-testid="sendcase-verify-panel" className="rounded-2xl border-2 border-cyan-300 bg-cyan-50/40 p-5 space-y-3">
            <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-full bg-cyan-100 text-cyan-700 grid place-items-center font-mono-tr text-lg">@</div>
                <div className="flex-1 min-w-0">
                    <div className="font-display text-[15px] text-slate-900 tracking-tight">Check your email</div>
                    <div className="text-[12.5px] text-slate-600 mt-0.5">
                        We sent a 6-digit code to <strong>{emailVerify.email}</strong>. Enter it to finish submitting your case.
                    </div>
                </div>
            </div>
            <input
                autoFocus
                type="text"
                inputMode="numeric"
                maxLength={6}
                value={verifyCode}
                onChange={(e) => { setVerifyCode(e.target.value.replace(/\D/g, "").slice(0, 6)); setVerifyError(null); }}
                data-testid="sendcase-verify-input"
                placeholder="••••••"
                className="w-full px-4 py-4 rounded-xl border-2 border-slate-300 focus:border-cyan-500 outline-none text-center font-mono-tr text-3xl tracking-[0.6em] text-slate-900 placeholder:text-slate-300 placeholder:tracking-[0.3em]"
            />
            {verifyError && (
                <div data-testid="sendcase-verify-error" className="rounded-lg bg-rose-50 border border-rose-200 px-3 py-2.5 text-[12.5px] text-rose-800">{verifyError}</div>
            )}
            <button
                type="button"
                onClick={onSubmit}
                disabled={submitting || verifyCode.length !== 6}
                data-testid="sendcase-verify-submit"
                className="w-full tr-btn justify-center !py-4 disabled:opacity-60 disabled:cursor-not-allowed"
            >
                {submitting ? <Loader2 size={15} className="animate-spin" /> : <CheckCircle2 size={15} />}
                Verify & submit case <ArrowRight size={15} />
            </button>
            <div className="flex items-center justify-between text-[12.5px] text-slate-500">
                <button type="button" onClick={onBack} data-testid="sendcase-verify-back" className="hover:text-slate-900">
                    ← Edit case details
                </button>
                <button
                    type="button"
                    onClick={onResend}
                    disabled={resendCooldown > 0}
                    data-testid="sendcase-verify-resend"
                    className={`${resendCooldown > 0 ? "text-slate-400 cursor-not-allowed" : "text-cyan-700 hover:text-cyan-900"}`}
                >
                    {resendCooldown > 0 ? `Resend in ${resendCooldown}s` : "Resend code"}
                </button>
            </div>
        </div>
    );
}
